import * as React from "react";
import { DeliveryIntervalSelectContainer } from "../../../../../../../../components/DeliveryIntervalSelect/modules/EcommContent/components/DeliveryIntervalSelect/DeliveryIntervalSelectContainer.js";
import { useCLEcommContext } from "../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLDeliveryIntervalSelect = ({ className }) => {
  const { actions, state, triggerToastMessage } = useCLEcommContext();
  const { deliveryInterval } = state.configurations.subscriptionPurchaseConfigurations;
  const {
    deliveryInterval: { showError },
    invalidSubmissionsCount
  } = state.configurator;
  React.useEffect(() => {
    if (showError) {
      triggerToastMessage("delivery-interval-error");
    }
  }, [showError, invalidSubmissionsCount, triggerToastMessage]);
  return /* @__PURE__ */ React.createElement(
    DeliveryIntervalSelectContainer,
    {
      className,
      hasError: showError,
      deliveryInterval,
      onIntervalSelection: actions.updateDeliveryInterval
    }
  );
};
export {
  CLDeliveryIntervalSelect
};
//# sourceMappingURL=CLDeliveryIntervalSelect.js.map
